import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";
import highchartsMore from "highcharts/highcharts-more.js";
import xRange from "highcharts/modules/xrange.js";
import { Box } from "@material-ui/core";

highchartsMore(Highcharts);
xRange(Highcharts);

Highcharts.setOptions({
    lang: {
        resetZoom: "Quitar zoom",
        months: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ],
        shortMonths: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ag",
            "Sep",
            "Oct",
            "Nov",
            "Dic",
        ],
        weekdays: [
            "Domingo",
            "Lunes",
            "Martes",
            "Miercoles",
            "Jueves",
            "Viernes",
            "Sabado",
        ],
        shortWeekdays: ["D", "L", "M", "Mi", "J", "V", "S"],
    },
});
export function ObjectiveZoomGraph({ categories, series, openModal }) {
    const [containerHeight, setContainerHeight] = React.useState(50);
    
    function generateBaseOptions(categories, series) {
        const updatedSeries = series.map(s => ({
            ...s,
            pointWidth: 15, // <--- Ajusta este valor (ej: 25 o 30) para controlar el alto de las barras
        }));
        return {
            chart: {
                type: "xrange",
                zoomType: "x",
                scrollablePlotArea: {
                    minWidth: 1000,
                },
            },
            title: {
                text: null,
            },
            xAxis: {
                type: "datetime",
                gridLineWidth: 0,
                minRange: 60 * 1000,
                dateTimeLabelFormats: {
                    day: "%e %b %Y",
                    hour: "%H:%M",
                    minute: "%H:%M",
                },
                tickPixelInterval: 200, // Intervalo en píxeles para los ticks
                minTickInterval: 200,
                units: [
                    ["minute", [5, 15, 30]], // Muestra ticks cada 30 minutos
                    ["hour", [1, 2]], // Muestra ticks cada 1 hora
                    ["day", [1]], // Muestra ticks cada 1 día
                ],
                opposite: true,
            },
            yAxis: {
                title: {
                    text: "",
                },
                labels: {
                    useHTML: true,
                    style: {
                        whiteSpace: "normal",
                    },
                    formatter: function () {
                        var objNameLabel = this.value;
                        return (
                            '<div style="word-wrap: break-word;word-break: break-all;" class="graph-label-container">' +
                            objNameLabel +
                            "</div>"
                        );
                    },
                },
                categories,
            },
            series: updatedSeries,
            plotOptions: {
                series: {
                    borderRadius: 0,
                    borderColor: "transparent",
                    pointWidth: 10,
                    turboThreshold: 0,
                    grouping: false,
                    cursor: "pointer",
                    point: {
                        events: {
                            click: (e) => {
                                openModal(e.point.yCategory);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: false,
            },
            credits: {
                enabled: false,
            },
            tooltip: {
                backgroundColor: "rgba(255,255,255,0)",
                shadow: false,
                useHTML: true,
                className: 'general-status',
                xDateFormat: '%A, %b %e, %Y %H:%M:%S',
                padding: 1,
            }
        };
    }

    const chartOptions = generateBaseOptions(categories, series);
    const categoriesQ = categories.length;

    return (
        <Box sx={{ height: containerHeight }}>
            <HighchartsReact
                key={categories.length}
                highcharts={Highcharts}
                options={chartOptions}
                callback={(chart) => {
                    const height = 400 - chart.plotBox.height + categoriesQ * 20;
                    chart.setSize(null, height);
                    chart.hasUserSize = null;
                    setContainerHeight(height);
                }}
            />
        </Box>
    );
}